import type { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BooleanType: { input: any; output: any; }
  CustomData: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FloatType: { input: any; output: any; }
  IntType: { input: any; output: any; }
  ItemId: { input: any; output: any; }
  JsonField: { input: any; output: any; }
  MetaTagAttributes: { input: any; output: any; }
  UploadId: { input: any; output: any; }
};

export type ArticleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<StringFilter>;
  body?: InputMaybe<StructuredTextFilter>;
  category?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  excerpt?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  readTime?: InputMaybe<StringFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ArticleModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Author_ASC = 'author_ASC',
  Author_DESC = 'author_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  ReadTime_ASC = 'readTime_ASC',
  ReadTime_DESC = 'readTime_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type CategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export enum ColorBucketType {
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  answer?: InputMaybe<TextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  question?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FaqModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Question_ASC = 'question_ASC',
  Question_DESC = 'question_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export enum FaviconType {
  AppleTouchIcon = 'appleTouchIcon',
  Icon = 'icon',
  MsApplication = 'msApplication'
}

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter Floating-point fields */
export type FloatFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['FloatType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['FloatType']['input']>;
};

/** Specifies how to filter Multiple files/images field */
export type GalleryFilter = {
  /** Filter records that have all of the specified uploads. The specified values must be Upload IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Filter records that have one of the specified uploads. The specified values must be Upload IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Upload IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that do not have any of the specified uploads. The specified values must be Upload IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/ar)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/auto)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/bg)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-remove)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-remove)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-replace)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-replace)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-replace-neg-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-h)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-pad)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-w)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-x)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-y)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-radius-inner)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/bri)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/ch)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/chromasub)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/colorquant)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/color-palette/colors)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/con)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/mask/corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/crop)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/cs)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/dl)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/dpi)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/dpr)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/exp)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/expires)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/face-detection/faceindex)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/face-detection/facepad)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/face-detection/faces)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-neg-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-pos)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-cs)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/fit)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/rotation/flip)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/fm)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-x)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-y)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-z)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/gam)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/h)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/high)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/htn)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/hue)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/lossless)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-align)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-base)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-fit)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-h)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-pad)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-rot)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-w)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-x)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-y)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/mask)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/mask/mask-bg)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/max-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/max-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/min-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/min-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/noise-reduction/nr)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/noise-reduction/nrs)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/rotation/orient)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/pdf/page)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/color-palette/palette)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/color-palette/prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/px)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/q)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/rect)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/rotation/rot)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/sat)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/sepia)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/shad)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/sharp)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-md)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-pad)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-sd)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-tol)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-clip)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-fit)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/typesetting/txt-lead)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-line)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-line-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-pad)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-shad)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/typesetting/txt-track)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-x)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-y)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution/upscale)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution/upscale-fallback)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/usm)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/usmrad)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/vib)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/w)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  Compress = 'compress',
  Enhance = 'enhance',
  Format = 'format',
  Redeye = 'redeye'
}

export enum ImgixParamsBlendAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendCrop {
  Bottom = 'bottom',
  Faces = 'faces',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsBlendMode {
  Burn = 'burn',
  Color = 'color',
  Darken = 'darken',
  Difference = 'difference',
  Dodge = 'dodge',
  Exclusion = 'exclusion',
  Hardlight = 'hardlight',
  Hue = 'hue',
  Lighten = 'lighten',
  Luminosity = 'luminosity',
  Multiply = 'multiply',
  Normal = 'normal',
  Overlay = 'overlay',
  Saturation = 'saturation',
  Screen = 'screen',
  Softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  Inherit = 'inherit'
}

export enum ImgixParamsCh {
  Dpr = 'dpr',
  SaveData = 'saveData',
  Width = 'width'
}

export enum ImgixParamsCrop {
  Bottom = 'bottom',
  Edges = 'edges',
  Entropy = 'entropy',
  Faces = 'faces',
  Focalpoint = 'focalpoint',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsCs {
  Adobergb1998 = 'adobergb1998',
  Srgb = 'srgb',
  Strip = 'strip',
  Tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  Blur = 'blur',
  Gen = 'gen',
  Generative = 'generative',
  Gradient = 'gradient',
  Solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientCs {
  Hsl = 'hsl',
  Lch = 'lch',
  Linear = 'linear',
  Oklab = 'oklab',
  Srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientType {
  Linear = 'linear',
  Radial = 'radial'
}

export enum ImgixParamsFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Facearea = 'facearea',
  Fill = 'fill',
  Fillmax = 'fillmax',
  Max = 'max',
  Min = 'min',
  Scale = 'scale'
}

export enum ImgixParamsFlip {
  H = 'h',
  Hv = 'hv',
  V = 'v'
}

export enum ImgixParamsFm {
  Avif = 'avif',
  Blurhash = 'blurhash',
  Gif = 'gif',
  Jp2 = 'jp2',
  Jpg = 'jpg',
  Json = 'json',
  Jxr = 'jxr',
  Mp4 = 'mp4',
  Pjpg = 'pjpg',
  Png = 'png',
  Png8 = 'png8',
  Png32 = 'png32',
  Webm = 'webm',
  Webp = 'webp'
}

export enum ImgixParamsIptc {
  Allow = 'allow',
  Block = 'block'
}

export enum ImgixParamsMarkAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsMarkFit {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsMarkTile {
  Grid = 'grid'
}

export enum ImgixParamsPalette {
  Css = 'css',
  Json = 'json'
}

export enum ImgixParamsTransparency {
  Grid = 'grid'
}

export enum ImgixParamsTrim {
  Auto = 'auto',
  Color = 'color'
}

export enum ImgixParamsTxtAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsTxtClip {
  Ellipsis = 'ellipsis',
  End = 'end',
  Middle = 'middle',
  Start = 'start'
}

export enum ImgixParamsTxtFit {
  Max = 'max'
}

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated'
}

/** Specifies how to filter JSON fields */
export type JsonFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export type LogoModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LogoModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LogoModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  link?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum LogoModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Link_ASC = 'link_ASC',
  Link_DESC = 'link_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type MenuCtaModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuCtaModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuCtaModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  primary?: InputMaybe<BooleanFilter>;
  reference?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MenuCtaModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Primary_ASC = 'primary_ASC',
  Primary_DESC = 'primary_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type MenuFooterModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuFooterModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuFooterModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  reference?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MenuFooterModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type MenuModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  query?: InputMaybe<LinkFilter>;
  reference?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MenuModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export enum MuxThumbnailFormatType {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png'
}

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

export type PageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  position?: InputMaybe<PositionFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum PageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by parent (tree-like collections only) */
export type ParentFilter = {
  /** Filter records children of the specified record. Value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with a parent record or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export type ProgramCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProgramCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProgramCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  categoryLink?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  programCategory?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProgramCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  ProgramCategory_ASC = 'programCategory_ASC',
  ProgramCategory_DESC = 'programCategory_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type ProgramProductModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProgramProductModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProgramProductModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  body?: InputMaybe<StructuredTextFilter>;
  category?: InputMaybe<LinkFilter>;
  clampingMethod?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  customDimensions?: InputMaybe<BooleanFilter>;
  customGranulation?: InputMaybe<BooleanFilter>;
  customMountingHoleSize?: InputMaybe<BooleanFilter>;
  discDiameter?: InputMaybe<JsonFilter>;
  displayTehnicalDetails?: InputMaybe<BooleanFilter>;
  excludeRecordFromSearchEngines?: InputMaybe<BooleanFilter>;
  grainType?: InputMaybe<JsonFilter>;
  granulation?: InputMaybe<JsonFilter>;
  id?: InputMaybe<ItemIdFilter>;
  material?: InputMaybe<JsonFilter>;
  mountingHoleSize?: InputMaybe<JsonFilter>;
  numberOfHoles?: InputMaybe<JsonFilter>;
  pdfLink?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  product?: InputMaybe<StringFilter>;
  productImage?: InputMaybe<FileFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  surfaceType?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProgramProductModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  CustomDimensions_ASC = 'customDimensions_ASC',
  CustomDimensions_DESC = 'customDimensions_DESC',
  CustomGranulation_ASC = 'customGranulation_ASC',
  CustomGranulation_DESC = 'customGranulation_DESC',
  CustomMountingHoleSize_ASC = 'customMountingHoleSize_ASC',
  CustomMountingHoleSize_DESC = 'customMountingHoleSize_DESC',
  DisplayTehnicalDetails_ASC = 'displayTehnicalDetails_ASC',
  DisplayTehnicalDetails_DESC = 'displayTehnicalDetails_DESC',
  ExcludeRecordFromSearchEngines_ASC = 'excludeRecordFromSearchEngines_ASC',
  ExcludeRecordFromSearchEngines_DESC = 'excludeRecordFromSearchEngines_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  PdfLink_ASC = 'pdfLink_ASC',
  PdfLink_DESC = 'pdfLink_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Product_ASC = 'product_ASC',
  Product_DESC = 'product_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export type SegmentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SegmentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SegmentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  headline?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SegmentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Headline_ASC = 'headline_ASC',
  Headline_DESC = 'headline_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type ShopCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ShopCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ShopCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ShopCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type ShopProductModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ShopProductModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ShopProductModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  additionalProductLink?: InputMaybe<LinkFilter>;
  body?: InputMaybe<StructuredTextFilter>;
  category?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  images?: InputMaybe<GalleryFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  price?: InputMaybe<FloatFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  tag?: InputMaybe<TextFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  variation?: InputMaybe<StringFilter>;
};

export enum ShopProductModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  Price_ASC = 'price_ASC',
  Price_DESC = 'price_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Variation_ASC = 'variation_ASC',
  Variation_DESC = 'variation_DESC'
}

export enum SiteLocale {
  En = 'en',
  Sl = 'sl'
}

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TestimonialModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TestimonialModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TestimonialModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  body?: InputMaybe<TextFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TestimonialModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Company_ASC = 'company_ASC',
  Company_DESC = 'company_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Basename_ASC = 'basename_ASC',
  Basename_DESC = 'basename_DESC',
  Filename_ASC = 'filename_ASC',
  Filename_DESC = 'filename_DESC',
  Format_ASC = 'format_ASC',
  Format_DESC = 'format_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MimeType_ASC = 'mimeType_ASC',
  MimeType_DESC = 'mimeType_DESC',
  Resolution_ASC = 'resolution_ASC',
  Resolution_DESC = 'resolution_DESC',
  Size_ASC = 'size_ASC',
  Size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  Archive = 'archive',
  Audio = 'audio',
  Image = 'image',
  Pdfdocument = 'pdfdocument',
  Presentation = 'presentation',
  Richtext = 'richtext',
  Spreadsheet = 'spreadsheet',
  Video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export enum VideoMp4Res {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type AppQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  publishTranslation?: InputMaybe<Scalars['BooleanType']['input']>;
}>;


export type AppQuery = { _site: { locales: Array<SiteLocale>, globalSeo?: { siteName?: string | null, titleSuffix?: string | null } | null, favicon?: { url: string } | null, faviconMetaTags: Array<{ tag: string, content?: string | null, attributes?: any | null }> }, allMenus: Array<{ id: any, externalLink?: string | null, title?: string | null, description?: string | null, publishTranslation?: any | null, children: Array<{ id: any, title?: string | null, description?: string | null, externalLink?: string | null, publishTranslation?: any | null, parent?: { id: any } | null, reference?: { slug?: string | null } | null, query?: { __typename: 'CategoryRecord', _modelApiKey: string, id: any, name?: string | null } | null }>, parent?: { id: any } | null, reference?: { _modelApiKey: string, slug?: string | null } | null, query?: { __typename: 'CategoryRecord', _modelApiKey: string, id: any, name?: string | null } | null, blocks: Array<{ __typename: 'MenuBlockCtaRecord', id: any, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'MenuBlockRecord', title?: string | null, reference: Array<{ __typename: 'ArticleRecord', _modelApiKey: string, title?: string | null, slug?: string | null } | { __typename: 'PageRecord', _modelApiKey: string, title?: string | null, slug?: string | null }> }> }>, allMenuCtas: Array<{ title?: string | null, primary?: any | null, externalLink?: string | null, reference?: { __typename: 'PageRecord', title?: string | null, slug?: string | null } | null }>, allMenuFooters: Array<{ id: any, externalLink?: string | null, title?: string | null, publishTranslation?: any | null, parent?: { id: any } | null, reference?: { _modelApiKey: string, slug?: string | null } | null }>, allCategories: Array<{ __typename: 'CategoryRecord', id: any, name?: string | null }>, allShopCategories: Array<{ __typename: 'ShopCategoryRecord', _modelApiKey: string, createdAt: any, id: any, description?: string | null, title?: string | null, slug?: string | null, publishTranslation?: any | null, noIndex?: any | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> }> };

export type ArticlesQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
  publishTranslation?: InputMaybe<Scalars['BooleanType']['input']>;
}>;


export type ArticlesQuery = { _allArticlesMeta: { count: any }, allArticles: Array<{ __typename: 'ArticleRecord', _modelApiKey: string, excerpt?: string | null, id: any, title?: string | null, slug?: string | null, publishTranslation?: any | null, noIndex?: any | null, category: Array<{ id: any, name?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type ArticleQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArticleQuery = { article?: { __typename: 'ArticleRecord', _modelApiKey: string, author?: string | null, createdAt: any, id: any, excerpt?: string | null, readTime?: string | null, title?: string | null, slug?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, category: Array<{ id: any, name?: string | null }>, body?: { value: any, blocks: Array<{ __typename: 'ButtonRecord', id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HtmlRecord', id: any, code?: string | null } | { __typename: 'ImageGalleryRecord', id: any, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'ImageRecord', id: any, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord', id: any, table?: any | null } | { __typename: 'TestimonialListRecord', id: any, testimonials: Array<{ body?: string | null, name?: string | null, company?: string | null }> } | { __typename: 'VideoEmbedRecord', id: any, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }>, links: Array<{ __typename: 'ArticleRecord', id: any, slug?: string | null, title?: string | null } | { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null }> } | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type ButtonFragment = { id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null };

export type CallToActionFragment = { externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null };

export type ImageFragment = { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null };

export type TableFragment = { id: any, table?: any | null };

export type VideoEmbedFragment = { video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null };

export type FaqFragment = { id: any, question?: string | null, answer?: string | null };

export type ProgramCategoryFragment = { programCategory?: string | null, description?: string | null, categoryLink?: { id: any, slug?: string | null } | null };

export type SectionHeroFragment = { title?: string | null, subtitle?: string | null, html?: string | null, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

export type SectionHero2Fragment = { title?: string | null, subtitle?: string | null, html?: string | null, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

export type SectionHero3Fragment = { title?: string | null, html?: string | null, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> };

export type SectionShopHeroFragment = { title?: string | null, subtitle?: string | null };

export type SectionTitleFragment = { title?: string | null, html?: string | null };

export type SectionThankYouFragment = { title?: string | null, subtitle?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

export type IndexQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type IndexQuery = { index?: { _modelApiKey: string, title?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, hero: Array<{ __typename: 'SectionHero2Record', title?: string | null, subtitle?: string | null, html?: string | null, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionHero3Record', title?: string | null, html?: string | null, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionHeroRecord', title?: string | null, subtitle?: string | null, html?: string | null, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionThankYouRecord', title?: string | null, subtitle?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionTitleRecord', title?: string | null, html?: string | null }>, blocks: Array<{ __typename: 'SectionArticleListRecord', id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> } | { __typename: 'SectionBodyRecord', id: any, body?: { value: any, blocks: Array<{ __typename: 'ButtonRecord', id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HtmlRecord', id: any, code?: string | null } | { __typename: 'ImageRecord', id: any, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord' } | { __typename: 'VideoEmbedRecord', video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }>, links: Array<{ __typename: 'ArticleRecord', id: any, slug?: string | null, title?: string | null } | { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | { __typename: 'ProgramProductRecord' }> } | null } | { __typename: 'SectionCatalogRecord', id: any, title?: string | null, html?: string | null, images: Array<{ id: any, alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }>, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionContactFormRecord', id: any, html?: string | null, title?: string | null } | { __typename: 'SectionCtaRecord', id: any, html?: string | null, title?: string | null, variant?: string | null, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionFaqRecord', id: any, title?: string | null, subHeadline?: string | null, backgroundColor?: string | null, faq: Array<{ id: any, question?: string | null, answer?: string | null }>, button: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionFeaturesListRecord', id: any, title?: string | null, subtitle?: string | null, features: Array<{ title?: string | null, body?: string | null }> } | { __typename: 'SectionImageGalleryRecord', id: any, title?: string | null, images: Array<{ id: any, alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionInquiryFormRecord', id: any, contactNumber?: string | null } | { __typename: 'SectionLogosListRecord', id: any, title?: string | null, logos: Array<{ name?: string | null, link?: string | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionMediaHorizontalRecord', id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMediaVerticalRecord', id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaSmall?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMediafullRecord', id: any, fullWidthVideo?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null, fullWidthImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMultipleRecord', id: any, multipleEntries: Array<{ heading?: string | null, descriptionText?: string | null, links: Array<{ __typename: 'ArticleRecord', id: any, title?: string | null, slug?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionPositionRecord', id: any, title?: string | null, background?: string | null, positionslot: Array<{ heading?: string | null, descriptionText?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionProductListRecord', id: any, heading?: string | null, descriptionText?: string | null, product: Array<{ __typename: 'ProgramProductRecord', _modelApiKey: string, slug?: string | null, product?: string | null, productImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, category?: { id: any, programCategory?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null } | null }> } | { __typename: 'SectionProgramRecord', id: any, headline?: string | null, programCategories: Array<{ id: any, programCategory?: string | null, description?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionProgrameRecord', id: any, heading?: string | null, programe: Array<{ programCategory?: string | null, description?: string | null, categoryLink?: { id: any, slug?: string | null } | null }> } | { __typename: 'SectionRelatedArticlesListRecord', id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, name?: string | null }>, overrideArticles: Array<{ __typename: 'ArticleRecord', _modelApiKey: string, excerpt?: string | null, id: any, title?: string | null, slug?: string | null, category: Array<{ id: any, name?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionRelatedShopProductsListRecord', id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, title?: string | null, description?: string | null }> } | { __typename: 'SectionSegmentRecord', id: any, title?: string | null, headline?: string | null, html?: string | null, overrideSegments: Array<{ headline?: string | null, description?: string | null }> } | { __typename: 'SectionStackRecord', id: any, stacks: Array<{ heading?: string | null, descriptionText?: string | null }> } | { __typename: 'SectionTestimonialsListRecord', id: any, headline?: string | null, backgroundColour?: any | null, testimonials: Array<{ body?: string | null, name?: string | null, company?: string | null }> } | { __typename: 'SectionVideoRecord', id: any, title?: string | null, html?: string | null, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }>, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type PageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type PageQuery = { page?: { _modelApiKey: string, id: any, slug?: string | null, title?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, hero: Array<{ __typename: 'SectionHero2Record', title?: string | null, subtitle?: string | null, html?: string | null, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionHero3Record', title?: string | null, html?: string | null, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionHeroRecord', title?: string | null, subtitle?: string | null, html?: string | null, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionShopHeroRecord', title?: string | null, subtitle?: string | null } | { __typename: 'SectionThankYouRecord', title?: string | null, subtitle?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionTitleRecord', title?: string | null, html?: string | null }>, blocks: Array<{ __typename: 'SectionArticleListRecord', id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> } | { __typename: 'SectionBodyRecord', id: any, body?: { value: any, blocks: Array<{ __typename: 'ButtonRecord', id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HtmlRecord', id: any, code?: string | null } | { __typename: 'ImageRecord', id: any, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord' } | { __typename: 'VideoEmbedRecord', video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }>, links: Array<{ __typename: 'ArticleRecord', id: any, slug?: string | null, title?: string | null } | { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | { __typename: 'ProgramProductRecord' }> } | null } | { __typename: 'SectionCatalogRecord', id: any, title?: string | null, html?: string | null, images: Array<{ id: any, alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }>, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionContactFormRecord', id: any, html?: string | null, title?: string | null } | { __typename: 'SectionCtaRecord', id: any, html?: string | null, title?: string | null, variant?: string | null, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionFaqRecord', id: any, title?: string | null, subHeadline?: string | null, backgroundColor?: string | null, faq: Array<{ id: any, question?: string | null, answer?: string | null }>, button: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionFeaturesListRecord', id: any, title?: string | null, subtitle?: string | null, features: Array<{ title?: string | null, body?: string | null }> } | { __typename: 'SectionImageGalleryRecord', id: any, title?: string | null, images: Array<{ id: any, alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionInquiryFormRecord', id: any, contactNumber?: string | null } | { __typename: 'SectionLogosListRecord', id: any, title?: string | null, logos: Array<{ name?: string | null, link?: string | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionMediaHorizontalRecord', id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMediaVerticalRecord', id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaSmall?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMediafullRecord', id: any, fullWidthVideo?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null, fullWidthImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMultipleRecord', id: any, multipleEntries: Array<{ heading?: string | null, descriptionText?: string | null, links: Array<{ __typename: 'ArticleRecord', id: any, title?: string | null, slug?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionPositionRecord', id: any, title?: string | null, background?: string | null, positionslot: Array<{ heading?: string | null, descriptionText?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionProductListRecord', id: any, heading?: string | null, descriptionText?: string | null, product: Array<{ __typename: 'ProgramProductRecord', _modelApiKey: string, slug?: string | null, product?: string | null, productImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, category?: { id: any, programCategory?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null } | null }> } | { __typename: 'SectionProgramRecord', id: any, headline?: string | null, programCategories: Array<{ id: any, programCategory?: string | null, description?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionProgrameRecord', id: any, heading?: string | null, programe: Array<{ programCategory?: string | null, description?: string | null, categoryLink?: { id: any, slug?: string | null } | null }> } | { __typename: 'SectionRelatedArticlesListRecord', id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, name?: string | null }>, overrideArticles: Array<{ __typename: 'ArticleRecord', _modelApiKey: string, excerpt?: string | null, id: any, title?: string | null, slug?: string | null, category: Array<{ id: any, name?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionRelatedShopProductsListRecord', id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, title?: string | null, description?: string | null }> } | { __typename: 'SectionSegmentRecord', id: any, title?: string | null, headline?: string | null, html?: string | null, overrideSegments: Array<{ headline?: string | null, description?: string | null }> } | { __typename: 'SectionShopProductListRecord', id: any, productLimit?: any | null } | { __typename: 'SectionStackRecord', id: any, stacks: Array<{ heading?: string | null, descriptionText?: string | null }> } | { __typename: 'SectionTestimonialsListRecord', id: any, headline?: string | null, backgroundColour?: any | null, testimonials: Array<{ body?: string | null, name?: string | null, company?: string | null }> } | { __typename: 'SectionVideoRecord', id: any, title?: string | null, html?: string | null, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }>, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type ProgramCategoriesQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type ProgramCategoriesQuery = { _allProgramCategoriesMeta: { count: any }, allProgramCategories: Array<{ id: any, programCategory?: string | null, description?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null }> };

export type ProgramProductsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
}>;


export type ProgramProductsQuery = { _allProgramProductsMeta: { count: any }, allProgramProducts: Array<{ __typename: 'ProgramProductRecord', _modelApiKey: string, slug?: string | null, product?: string | null, pdfLink?: string | null, customDimensions?: any | null, customGranulation?: any | null, customMountingHoleSize?: any | null, granulation?: any | null, discDiameter?: any | null, mountingHoleSize?: any | null, grainType?: any | null, surfaceType?: any | null, clampingMethod?: any | null, numberOfHoles?: any | null, material?: any | null, productImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, category?: { id: any, programCategory?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null } | null }> };

export type ProgramProductQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProgramProductQuery = { programProduct?: { displayTehnicalDetails?: any | null, product?: string | null, pdfLink?: string | null, customDimensions?: any | null, customGranulation?: any | null, customMountingHoleSize?: any | null, granulation?: any | null, discDiameter?: any | null, mountingHoleSize?: any | null, grainType?: any | null, surfaceType?: any | null, clampingMethod?: any | null, numberOfHoles?: any | null, material?: any | null, slug?: string | null, publishTranslation?: any | null, excludeRecordFromSearchEngines?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, productImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, category?: { id: any, programCategory?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null } | null, blocks: Array<{ __typename: 'SectionFaqRecord', id: any, title?: string | null, subHeadline?: string | null, backgroundColor?: string | null, faq: Array<{ id: any, question?: string | null, answer?: string | null }>, button: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionHero3Record', title?: string | null, html?: string | null, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionMediaHorizontalRecord', id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMediaVerticalRecord', id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaSmall?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMediafullRecord', id: any, fullWidthVideo?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null, fullWidthImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMultipleRecord', id: any, multipleEntries: Array<{ heading?: string | null, descriptionText?: string | null, links: Array<{ __typename: 'ArticleRecord', id: any, title?: string | null, slug?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionPositionRecord', id: any, title?: string | null, background?: string | null, positionslot: Array<{ heading?: string | null, descriptionText?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionProductListRecord' } | { __typename: 'SectionRelatedShopProductsListRecord', id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, title?: string | null, description?: string | null }> } | { __typename: 'SectionSegmentRecord', id: any, title?: string | null, headline?: string | null, html?: string | null, overrideSegments: Array<{ headline?: string | null, description?: string | null }> } | { __typename: 'SectionShopProductListRecord', id: any, productLimit?: any | null } | { __typename: 'SectionStackRecord', id: any, stacks: Array<{ heading?: string | null, descriptionText?: string | null }> }>, productDetailHero: Array<{ title?: string | null, descriptionText?: string | null, heroImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }>, body?: { value: any, blocks: Array<{ __typename: 'ProductDetailsListRecord', title?: string | null, productDetails: Array<{ title?: string | null, body?: { value: any, blocks: Array<{ __typename: 'ButtonRecord', id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HtmlRecord', id: any, code?: string | null } | { __typename: 'ImageGalleryRecord', id: any, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'ImageRecord', id: any, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'MultipleImageRecord', id: any, leftImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, rightImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord', id: any, table?: any | null } | { __typename: 'TipRecord', id: any, headline?: string | null, descriptionText?: string | null, tipImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'VideoEmbedRecord', video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }> } | null }> }> } | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type SectionCtaFragment = { id: any, html?: string | null, title?: string | null, variant?: string | null, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

export type SectionBodyFragment = { id: any, body?: { value: any, blocks: Array<{ __typename: 'ButtonRecord', id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HtmlRecord', id: any, code?: string | null } | { __typename: 'ImageRecord', id: any, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord' } | { __typename: 'VideoEmbedRecord', video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }>, links: Array<{ __typename: 'ArticleRecord', id: any, slug?: string | null, title?: string | null } | { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | { __typename: 'ProgramProductRecord' }> } | null };

export type SectionArticlesFragment = { id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> };

export type SectionImageGalleryFragment = { id: any, title?: string | null, images: Array<{ id: any, alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> };

export type SectionContactFormFragment = { id: any, html?: string | null, title?: string | null };

export type SectionFeaturesFragment = { id: any, title?: string | null, subtitle?: string | null, features: Array<{ title?: string | null, body?: string | null }> };

export type SectionLogosFragment = { id: any, title?: string | null, logos: Array<{ name?: string | null, link?: string | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type SectionMediaVerticalFragment = { id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaSmall?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null };

export type SectionMediaHorizontalFragment = { id: any, html?: string | null, mediaPosition?: string | null, title?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null };

export type SectionRelatedArticlesFragment = { id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, name?: string | null }>, overrideArticles: Array<{ __typename: 'ArticleRecord', _modelApiKey: string, excerpt?: string | null, id: any, title?: string | null, slug?: string | null, category: Array<{ id: any, name?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type SectionTestimonialsFragment = { id: any, headline?: string | null, backgroundColour?: any | null, testimonials: Array<{ body?: string | null, name?: string | null, company?: string | null }> };

export type SectionVideoFragment = { id: any, title?: string | null, html?: string | null, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null };

export type SectionMediafullFragment = { id: any, fullWidthVideo?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null, fullWidthImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null };

export type SectionFaqFragment = { id: any, title?: string | null, subHeadline?: string | null, backgroundColor?: string | null, faq: Array<{ id: any, question?: string | null, answer?: string | null }>, button: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

export type SectionSegmentsFragment = { id: any, title?: string | null, headline?: string | null, html?: string | null, overrideSegments: Array<{ headline?: string | null, description?: string | null }> };

export type SectionProductListFragment = { id: any, heading?: string | null, descriptionText?: string | null, product: Array<{ __typename: 'ProgramProductRecord', _modelApiKey: string, slug?: string | null, product?: string | null, productImage?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, category?: { id: any, programCategory?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null } | null }> };

export type SectionPositionFragment = { id: any, title?: string | null, background?: string | null, positionslot: Array<{ heading?: string | null, descriptionText?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type SectionCatalogFragment = { id: any, title?: string | null, html?: string | null, images: Array<{ id: any, alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }>, buttons: Array<{ id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

export type SectionProgramsFragment = { id: any, headline?: string | null, programCategories: Array<{ id: any, programCategory?: string | null, description?: string | null, categoryLink?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null } | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type SectionStacksFragment = { id: any, stacks: Array<{ heading?: string | null, descriptionText?: string | null }> };

export type SectionMultipleFragment = { id: any, multipleEntries: Array<{ heading?: string | null, descriptionText?: string | null, links: Array<{ __typename: 'ArticleRecord', id: any, title?: string | null, slug?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type SectionProgrameFragment = { id: any, heading?: string | null, programe: Array<{ programCategory?: string | null, description?: string | null, categoryLink?: { id: any, slug?: string | null } | null }> };

export type SectionInquiryFormFragment = { id: any, contactNumber?: string | null };

export type SectionShopProductListFragment = { id: any, productLimit?: any | null };

export type SectionRelatedShopProductsListFragment = { id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, icon?: any | null, variant?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'IndexRecord' } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, title?: string | null, description?: string | null }> };

export type SegmentsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
}>;


export type SegmentsQuery = { _allSegmentsMeta: { count: any }, allSegments: Array<{ _modelApiKey: string, headline?: string | null, description?: string | null }> };

export type ShopProductsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
  publishTranslation?: InputMaybe<Scalars['BooleanType']['input']>;
}>;


export type ShopProductsQuery = { _allShopProductsMeta: { count: any }, allShopProducts: Array<{ _modelApiKey: string, description?: string | null, price?: any | null, id: any, title?: string | null, variation?: string | null, tag?: string | null, slug?: string | null, publishTranslation?: any | null, noIndex?: any | null, productFeatureOrDescription: Array<{ feature?: string | null, descriptionOrValue?: string | null }>, category: Array<{ title?: string | null, description?: string | null }>, additionalProductLink?: { __typename: 'ShopProductRecord', id: any, title?: string | null, slug?: string | null } | null, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> }> };

export type ShopProductQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShopProductQuery = { shopProduct?: { _modelApiKey: string, createdAt: any, id: any, description?: string | null, price?: any | null, variation?: string | null, tag?: string | null, title?: string | null, slug?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, productFeatureOrDescription: Array<{ feature?: string | null, descriptionOrValue?: string | null }>, category: Array<{ title?: string | null, description?: string | null }>, additionalProductLink?: { __typename: 'ShopProductRecord', id: any, title?: string | null, slug?: string | null } | null, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }>, body?: { value: any, blocks: Array<{ __typename: 'ButtonRecord', id: any, label?: string | null, variant?: string | null, icon?: any | null, externalLink?: string | null, reference?: { id: any, slug?: string | null } | { id: any, slug?: string | null } | null } | { __typename: 'HtmlRecord', id: any, code?: string | null } | { __typename: 'ImageGalleryRecord', id: any, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'ImageRecord', id: any, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord', id: any, table?: any | null } | { __typename: 'VideoEmbedRecord', id: any, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }>, links: Array<{ __typename: 'ArticleRecord', id: any, slug?: string | null, title?: string | null } | { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null }> } | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type ShopCategoryQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShopCategoryQuery = { shopCategory?: { _modelApiKey: string, createdAt: any, id: any, description?: string | null, title?: string | null, slug?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export const TableFragmentDoc = gql`
    fragment Table on TableRecord {
  id
  table
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on ResponsiveImage {
  srcSet
  webpSrcSet
  sizes
  src
  width
  height
  aspectRatio
  alt
  title
  bgColor
  base64
}
    `;
export const CallToActionFragmentDoc = gql`
    fragment CallToAction on CtaRecord {
  externalLink
  id
  pageLink {
    __typename
    ... on ArticleRecord {
      id
      slug
    }
    ... on PageRecord {
      id
      slug
    }
  }
  primary
  title
  icon
  variant
}
    `;
export const SectionHeroFragmentDoc = gql`
    fragment SectionHero on SectionHeroRecord {
  title
  subtitle
  html
  media {
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 1280}
    ) {
      ...Image
    }
  }
  buttons {
    ...CallToAction
  }
}
    `;
export const ButtonFragmentDoc = gql`
    fragment Button on ButtonRecord {
  id
  label
  variant
  icon
  reference {
    __typename
    ... on ArticleRecord {
      id
      slug
    }
    ... on PageRecord {
      id
      slug
    }
  }
  externalLink
}
    `;
export const SectionHero2FragmentDoc = gql`
    fragment SectionHero2 on SectionHero2Record {
  title
  subtitle
  html
  media {
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 1280}
    ) {
      ...Image
    }
  }
  buttons {
    ...Button
  }
}
    `;
export const SectionHero3FragmentDoc = gql`
    fragment SectionHero3 on SectionHero3Record {
  title
  html
  images {
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 192}
    ) {
      ...Image
    }
  }
}
    `;
export const SectionShopHeroFragmentDoc = gql`
    fragment SectionShopHero on SectionShopHeroRecord {
  title
  subtitle
}
    `;
export const SectionTitleFragmentDoc = gql`
    fragment SectionTitle on SectionTitleRecord {
  title
  html
}
    `;
export const SectionThankYouFragmentDoc = gql`
    fragment SectionThankYou on SectionThankYouRecord {
  title
  subtitle
  buttons {
    ...CallToAction
  }
}
    `;
export const SectionCtaFragmentDoc = gql`
    fragment SectionCta on SectionCtaRecord {
  id
  buttons {
    ...Button
  }
  html
  title
  variant
}
    `;
export const VideoEmbedFragmentDoc = gql`
    fragment VideoEmbed on VideoEmbedRecord {
  video {
    url
    title
    thumbnailUrl
    height
    provider
    providerUid
    width
  }
}
    `;
export const SectionBodyFragmentDoc = gql`
    fragment SectionBody on SectionBodyRecord {
  id
  body {
    blocks {
      __typename
      ...Button
      ... on HtmlRecord {
        id
        code
      }
      ... on ImageRecord {
        id
        image {
          alt
          url
          width
          height
          responsiveImage {
            ...Image
          }
        }
      }
      ...VideoEmbed
    }
    links {
      __typename
      ... on PageRecord {
        id
        title
        slug
      }
      ... on ArticleRecord {
        id
        slug
        title
      }
    }
    value
  }
}
    `;
export const SectionArticlesFragmentDoc = gql`
    fragment SectionArticles on SectionArticleListRecord {
  id
  categories {
    name
    id
  }
  itemsPerPage
  linkMore
  title
}
    `;
export const SectionImageGalleryFragmentDoc = gql`
    fragment SectionImageGallery on SectionImageGalleryRecord {
  id
  images {
    id
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 406}
    ) {
      ...Image
    }
  }
  title
}
    `;
export const SectionContactFormFragmentDoc = gql`
    fragment SectionContactForm on SectionContactFormRecord {
  id
  html
  title
}
    `;
export const SectionFeaturesFragmentDoc = gql`
    fragment SectionFeatures on SectionFeaturesListRecord {
  id
  title
  subtitle
  features {
    title
    body
  }
}
    `;
export const SectionLogosFragmentDoc = gql`
    fragment SectionLogos on SectionLogosListRecord {
  id
  title
  logos {
    name
    logo {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, h: 28}
      ) {
        ...Image
      }
    }
    link
  }
}
    `;
export const SectionMediaVerticalFragmentDoc = gql`
    fragment SectionMediaVertical on SectionMediaVerticalRecord {
  id
  buttons {
    ...CallToAction
  }
  html
  media {
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, h: 646, w: 846}
    ) {
      ...Image
    }
  }
  mediaSmall {
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, h: 646, w: 416}
    ) {
      ...Image
    }
  }
  mediaPosition
  title
}
    `;
export const SectionMediaHorizontalFragmentDoc = gql`
    fragment SectionMediaHorizontal on SectionMediaHorizontalRecord {
  id
  buttons {
    ...CallToAction
  }
  html
  media {
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 528, h: 528}
    ) {
      ...Image
    }
  }
  mediaPosition
  title
}
    `;
export const SectionRelatedArticlesFragmentDoc = gql`
    fragment SectionRelatedArticles on SectionRelatedArticlesListRecord {
  id
  button {
    ...CallToAction
  }
  categories {
    id
    name
  }
  overrideArticles {
    category {
      id
      name
    }
    _modelApiKey
    __typename
    excerpt
    id
    title
    slug
    image {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 608}
      ) {
        ...Image
      }
    }
  }
  title
}
    `;
export const SectionTestimonialsFragmentDoc = gql`
    fragment SectionTestimonials on SectionTestimonialsListRecord {
  id
  headline
  testimonials {
    body
    name
    company
  }
  backgroundColour
}
    `;
export const SectionVideoFragmentDoc = gql`
    fragment SectionVideo on SectionVideoRecord {
  id
  title
  video {
    url
    title
    thumbnailUrl
    height
    provider
    providerUid
    width
  }
  html
}
    `;
export const SectionMediafullFragmentDoc = gql`
    fragment SectionMediafull on SectionMediafullRecord {
  id
  fullWidthVideo {
    url
    title
    thumbnailUrl
    height
    provider
    providerUid
    width
  }
  fullWidthImage {
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 1312, h: 655}
    ) {
      ...Image
    }
  }
}
    `;
export const FaqFragmentDoc = gql`
    fragment Faq on FaqRecord {
  id
  question
  answer
}
    `;
export const SectionFaqFragmentDoc = gql`
    fragment SectionFaq on SectionFaqRecord {
  id
  title
  subHeadline
  faq {
    ...Faq
  }
  button {
    ...Button
  }
  backgroundColor
}
    `;
export const SectionSegmentsFragmentDoc = gql`
    fragment SectionSegments on SectionSegmentRecord {
  id
  title
  headline
  html
  overrideSegments {
    headline
    description
  }
}
    `;
export const SectionProductListFragmentDoc = gql`
    fragment SectionProductList on SectionProductListRecord {
  id
  heading
  descriptionText
  product {
    _modelApiKey
    __typename
    slug
    product
    productImage {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "3:2", w: 180}
      ) {
        ...Image
      }
    }
    category {
      id
      programCategory
      categoryLink {
        __typename
        ... on PageRecord {
          id
          title
          slug
        }
      }
    }
  }
}
    `;
export const SectionPositionFragmentDoc = gql`
    fragment SectionPosition on SectionPositionRecord {
  id
  title
  background
  positionslot {
    heading
    descriptionText
    image {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 640}
      ) {
        ...Image
      }
    }
  }
}
    `;
export const SectionCatalogFragmentDoc = gql`
    fragment SectionCatalog on SectionCatalogRecord {
  id
  title
  html
  images {
    id
    alt
    url
    width
    height
    responsiveImage(
      imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 212}
    ) {
      ...Image
    }
  }
  buttons {
    ...Button
  }
}
    `;
export const SectionProgramsFragmentDoc = gql`
    fragment SectionPrograms on SectionProgramRecord {
  id
  headline
  programCategories {
    id
    programCategory
    description
    categoryLink {
      __typename
      ... on PageRecord {
        id
        title
        slug
      }
    }
    image {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 640}
      ) {
        ...Image
      }
    }
  }
}
    `;
export const SectionStacksFragmentDoc = gql`
    fragment SectionStacks on SectionStackRecord {
  id
  stacks {
    heading
    descriptionText
  }
}
    `;
export const SectionMultipleFragmentDoc = gql`
    fragment SectionMultiple on SectionMultipleRecord {
  id
  multipleEntries {
    heading
    descriptionText
    links {
      __typename
      ... on ArticleRecord {
        id
        title
        slug
      }
    }
    image {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 640}
      ) {
        ...Image
      }
    }
  }
}
    `;
export const ProgramCategoryFragmentDoc = gql`
    fragment ProgramCategory on ProgramCategoryRecord {
  programCategory
  description
  categoryLink {
    ... on PageRecord {
      id
      slug
    }
  }
}
    `;
export const SectionProgrameFragmentDoc = gql`
    fragment SectionPrograme on SectionProgrameRecord {
  id
  heading
  programe {
    ...ProgramCategory
  }
}
    `;
export const SectionInquiryFormFragmentDoc = gql`
    fragment SectionInquiryForm on SectionInquiryFormRecord {
  id
  contactNumber
}
    `;
export const SectionShopProductListFragmentDoc = gql`
    fragment SectionShopProductList on SectionShopProductListRecord {
  id
  productLimit
}
    `;
export const SectionRelatedShopProductsListFragmentDoc = gql`
    fragment SectionRelatedShopProductsList on SectionRelatedShopProductsListRecord {
  id
  title
  button {
    ...CallToAction
  }
  categories {
    id
    title
    description
  }
}
    `;
export const AppDocument = gql`
    query app($locale: SiteLocale, $first: IntType = 100, $publishTranslation: BooleanType = true) {
  _site {
    globalSeo {
      siteName
      titleSuffix
    }
    favicon {
      url
    }
    faviconMetaTags {
      tag
      content
      attributes
    }
    locales
  }
  allMenus(
    first: $first
    locale: $locale
    filter: {publishTranslation: {eq: $publishTranslation}}
  ) {
    id
    children {
      id
      title
      description
      parent {
        id
      }
      reference {
        slug
      }
      query {
        _modelApiKey
        __typename
        id
        name
      }
      title
      externalLink
      publishTranslation
    }
    externalLink
    parent {
      id
    }
    reference {
      _modelApiKey
      slug
    }
    query {
      _modelApiKey
      __typename
      id
      name
    }
    title
    description
    blocks {
      __typename
      ... on MenuBlockRecord {
        reference {
          __typename
          ... on ArticleRecord {
            _modelApiKey
            title
            slug
          }
          ... on PageRecord {
            _modelApiKey
            title
            slug
          }
        }
        title
      }
      ... on MenuBlockCtaRecord {
        id
        buttons {
          ...CallToAction
        }
        title
      }
    }
    publishTranslation
  }
  allMenuCtas(locale: $locale) {
    title
    reference {
      __typename
      ... on PageRecord {
        title
        slug
      }
    }
    primary
    externalLink
  }
  allMenuFooters(
    locale: $locale
    filter: {publishTranslation: {eq: $publishTranslation}}
  ) {
    id
    externalLink
    parent {
      id
    }
    reference {
      _modelApiKey
      slug
    }
    title
    publishTranslation
  }
  allCategories(locale: $locale) {
    __typename
    id
    name
  }
  allShopCategories(locale: $locale, orderBy: _firstPublishedAt_DESC) {
    __typename
    _modelApiKey
    createdAt
    id
    description
    title
    slug
    publishTranslation
    noIndex
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${CallToActionFragmentDoc}`;
export const ArticlesDocument = gql`
    query articles($locale: SiteLocale, $first: IntType = 100, $skip: IntType, $eq: [ItemId], $neq: String, $anyIn: [ItemId], $publishTranslation: BooleanType = true) {
  _allArticlesMeta(
    locale: $locale
    filter: {category: {allIn: $eq}, publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
  ) {
    count
  }
  allArticles(
    locale: $locale
    first: $first
    skip: $skip
    filter: {category: {allIn: $eq, anyIn: $anyIn}, publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
    orderBy: _firstPublishedAt_DESC
  ) {
    _modelApiKey
    __typename
    category {
      id
      name
    }
    excerpt
    id
    image {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "4:3", w: 640}
      ) {
        ...Image
      }
    }
    title
    slug
    publishTranslation
    noIndex
  }
}
    ${ImageFragmentDoc}`;
export const ArticleDocument = gql`
    query article($locale: SiteLocale, $slug: String) {
  article(locale: $locale, filter: {slug: {eq: $slug}}) {
    _allSlugLocales {
      value
      locale
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    __typename
    author
    createdAt
    category {
      id
      name
    }
    id
    excerpt
    body {
      blocks {
        __typename
        ... on ButtonRecord {
          id
          label
          variant
          icon
          reference {
            __typename
            ... on ArticleRecord {
              id
              slug
            }
            ... on PageRecord {
              id
              slug
            }
          }
          externalLink
        }
        ... on HtmlRecord {
          id
          code
        }
        ... on ImageRecord {
          id
          image {
            alt
            url
            width
            height
            responsiveImage {
              ...Image
            }
          }
        }
        ... on ImageGalleryRecord {
          id
          images {
            alt
            url
            width
            height
            responsiveImage(
              imgixParams: {auto: format, crop: focalpoint, fit: crop, ar: "16:9"}
            ) {
              ...Image
            }
          }
        }
        ... on VideoEmbedRecord {
          id
          video {
            url
            title
            thumbnailUrl
            height
            provider
            providerUid
            width
          }
        }
        ... on TableRecord {
          id
          table
        }
        ... on TestimonialListRecord {
          id
          testimonials {
            body
            name
            company
          }
        }
      }
      links {
        __typename
        ... on PageRecord {
          id
          title
          slug
        }
        ... on ArticleRecord {
          id
          slug
          title
        }
      }
      value
    }
    image {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "21:9", w: 1440}
      ) {
        ...Image
      }
    }
    readTime
    title
    slug
    publishTranslation
    noIndex
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${ImageFragmentDoc}`;
export const IndexDocument = gql`
    query index($locale: SiteLocale) {
  index(locale: $locale) {
    _modelApiKey
    _allPublishTranslationLocales {
      value
      locale
    }
    title
    hero {
      __typename
      ...SectionHero
      ...SectionHero2
      ...SectionHero3
      ...SectionTitle
      ...SectionThankYou
    }
    blocks {
      __typename
      ...SectionArticles
      ...SectionContactForm
      ...SectionCta
      ...SectionBody
      ...SectionFeatures
      ...SectionImageGallery
      ...SectionLogos
      ...SectionMediaVertical
      ...SectionMediaHorizontal
      ...SectionRelatedArticles
      ...SectionTestimonials
      ...SectionVideo
      ...SectionMediafull
      ...SectionFaq
      ...SectionPrograme
      ...SectionCatalog
      ...SectionPrograms
      ...SectionPosition
      ...SectionSegments
      ...SectionProductList
      ...SectionStacks
      ...SectionMultiple
      ...SectionInquiryForm
      ...SectionRelatedShopProductsList
    }
    publishTranslation
    noIndex
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${SectionHeroFragmentDoc}
${ImageFragmentDoc}
${CallToActionFragmentDoc}
${SectionHero2FragmentDoc}
${ButtonFragmentDoc}
${SectionHero3FragmentDoc}
${SectionTitleFragmentDoc}
${SectionThankYouFragmentDoc}
${SectionArticlesFragmentDoc}
${SectionContactFormFragmentDoc}
${SectionCtaFragmentDoc}
${SectionBodyFragmentDoc}
${VideoEmbedFragmentDoc}
${SectionFeaturesFragmentDoc}
${SectionImageGalleryFragmentDoc}
${SectionLogosFragmentDoc}
${SectionMediaVerticalFragmentDoc}
${SectionMediaHorizontalFragmentDoc}
${SectionRelatedArticlesFragmentDoc}
${SectionTestimonialsFragmentDoc}
${SectionVideoFragmentDoc}
${SectionMediafullFragmentDoc}
${SectionFaqFragmentDoc}
${FaqFragmentDoc}
${SectionProgrameFragmentDoc}
${ProgramCategoryFragmentDoc}
${SectionCatalogFragmentDoc}
${SectionProgramsFragmentDoc}
${SectionPositionFragmentDoc}
${SectionSegmentsFragmentDoc}
${SectionProductListFragmentDoc}
${SectionStacksFragmentDoc}
${SectionMultipleFragmentDoc}
${SectionInquiryFormFragmentDoc}
${SectionRelatedShopProductsListFragmentDoc}`;
export const PageDocument = gql`
    query page($locale: SiteLocale, $slug: String) {
  page(locale: $locale, filter: {slug: {eq: $slug}}) {
    _allSlugLocales {
      locale
      value
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    id
    slug
    title
    publishTranslation
    noIndex
    hero {
      __typename
      ...SectionHero
      ...SectionHero2
      ...SectionHero3
      ...SectionShopHero
      ...SectionTitle
      ...SectionThankYou
    }
    blocks {
      __typename
      ...SectionArticles
      ...SectionContactForm
      ...SectionCta
      ...SectionBody
      ...SectionFeatures
      ...SectionImageGallery
      ...SectionLogos
      ...SectionMediaVertical
      ...SectionMediaHorizontal
      ...SectionRelatedArticles
      ...SectionTestimonials
      ...SectionVideo
      ...SectionMediafull
      ...SectionFaq
      ...SectionPrograms
      ...SectionPosition
      ...SectionSegments
      ...SectionProductList
      ...SectionStacks
      ...SectionCatalog
      ...SectionMultiple
      ...SectionPrograme
      ...SectionInquiryForm
      ...SectionShopProductList
      ...SectionRelatedShopProductsList
    }
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${SectionHeroFragmentDoc}
${ImageFragmentDoc}
${CallToActionFragmentDoc}
${SectionHero2FragmentDoc}
${ButtonFragmentDoc}
${SectionHero3FragmentDoc}
${SectionShopHeroFragmentDoc}
${SectionTitleFragmentDoc}
${SectionThankYouFragmentDoc}
${SectionArticlesFragmentDoc}
${SectionContactFormFragmentDoc}
${SectionCtaFragmentDoc}
${SectionBodyFragmentDoc}
${VideoEmbedFragmentDoc}
${SectionFeaturesFragmentDoc}
${SectionImageGalleryFragmentDoc}
${SectionLogosFragmentDoc}
${SectionMediaVerticalFragmentDoc}
${SectionMediaHorizontalFragmentDoc}
${SectionRelatedArticlesFragmentDoc}
${SectionTestimonialsFragmentDoc}
${SectionVideoFragmentDoc}
${SectionMediafullFragmentDoc}
${SectionFaqFragmentDoc}
${FaqFragmentDoc}
${SectionProgramsFragmentDoc}
${SectionPositionFragmentDoc}
${SectionSegmentsFragmentDoc}
${SectionProductListFragmentDoc}
${SectionStacksFragmentDoc}
${SectionCatalogFragmentDoc}
${SectionMultipleFragmentDoc}
${SectionProgrameFragmentDoc}
${ProgramCategoryFragmentDoc}
${SectionInquiryFormFragmentDoc}
${SectionShopProductListFragmentDoc}
${SectionRelatedShopProductsListFragmentDoc}`;
export const ProgramCategoriesDocument = gql`
    query programCategories($locale: SiteLocale) {
  _allProgramCategoriesMeta(locale: $locale) {
    count
  }
  allProgramCategories(locale: $locale, orderBy: _firstPublishedAt_DESC) {
    id
    programCategory
    description
    categoryLink {
      __typename
      ... on PageRecord {
        id
        title
        slug
      }
    }
  }
}
    `;
export const ProgramProductsDocument = gql`
    query programProducts($locale: SiteLocale, $first: IntType = 100, $skip: IntType) {
  _allProgramProductsMeta(locale: $locale) {
    count
  }
  allProgramProducts(
    locale: $locale
    first: $first
    skip: $skip
    orderBy: _firstPublishedAt_DESC
  ) {
    _modelApiKey
    __typename
    slug
    product
    pdfLink
    productImage {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "3:2", w: 180}
      ) {
        ...Image
      }
    }
    customDimensions
    customGranulation
    customMountingHoleSize
    granulation
    discDiameter
    mountingHoleSize
    grainType
    surfaceType
    clampingMethod
    numberOfHoles
    material
    category {
      id
      programCategory
      categoryLink {
        __typename
        ... on PageRecord {
          id
          title
          slug
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const ProgramProductDocument = gql`
    query programProduct($locale: SiteLocale, $slug: String) {
  programProduct(locale: $locale, filter: {slug: {eq: $slug}}) {
    _allSlugLocales {
      value
      locale
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    displayTehnicalDetails
    product
    pdfLink
    customDimensions
    customGranulation
    customMountingHoleSize
    granulation
    discDiameter
    mountingHoleSize
    grainType
    surfaceType
    clampingMethod
    numberOfHoles
    material
    productImage {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "3:2", w: 640}
      ) {
        ...Image
      }
    }
    category {
      id
      programCategory
      categoryLink {
        __typename
        ... on PageRecord {
          id
          title
          slug
        }
      }
    }
    blocks {
      __typename
      ...SectionHero3
      ...SectionMediaVertical
      ...SectionMediafull
      ...SectionPosition
      ...SectionMultiple
      ...SectionMediaHorizontal
      ...SectionFaq
      ...SectionStacks
      ...SectionSegments
      ...SectionShopProductList
      ...SectionRelatedShopProductsList
    }
    productDetailHero {
      ... on ProductDetailHeroRecord {
        title
        descriptionText
        heroImage {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "3:2", w: 640}
          ) {
            ...Image
          }
        }
      }
    }
    body {
      blocks {
        __typename
        ... on ProductDetailsListRecord {
          title
          productDetails {
            title
            body {
              blocks {
                __typename
                ...Button
                ... on HtmlRecord {
                  id
                  code
                }
                ... on ImageRecord {
                  id
                  image {
                    alt
                    url
                    width
                    height
                    responsiveImage(
                      imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 752}
                    ) {
                      ...Image
                    }
                  }
                }
                ... on ImageGalleryRecord {
                  id
                  images {
                    alt
                    url
                    width
                    height
                    responsiveImage(imgixParams: {auto: format, crop: focalpoint, fit: crop}) {
                      ...Image
                    }
                  }
                }
                ...VideoEmbed
                ...Table
                ... on TipRecord {
                  id
                  headline
                  descriptionText
                  tipImage {
                    alt
                    url
                    width
                    height
                    responsiveImage(
                      imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 360}
                    ) {
                      ...Image
                    }
                  }
                }
                ... on MultipleImageRecord {
                  id
                  leftImage {
                    alt
                    url
                    width
                    height
                    responsiveImage(imgixParams: {auto: compress, crop: focalpoint, fit: crop}) {
                      ...Image
                    }
                  }
                  rightImage {
                    alt
                    url
                    width
                    height
                    responsiveImage(imgixParams: {auto: compress, crop: focalpoint, fit: crop}) {
                      ...Image
                    }
                  }
                }
              }
              value
            }
          }
        }
      }
      value
    }
    slug
    publishTranslation
    excludeRecordFromSearchEngines
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${ImageFragmentDoc}
${SectionHero3FragmentDoc}
${SectionMediaVerticalFragmentDoc}
${CallToActionFragmentDoc}
${SectionMediafullFragmentDoc}
${SectionPositionFragmentDoc}
${SectionMultipleFragmentDoc}
${SectionMediaHorizontalFragmentDoc}
${SectionFaqFragmentDoc}
${FaqFragmentDoc}
${ButtonFragmentDoc}
${SectionStacksFragmentDoc}
${SectionSegmentsFragmentDoc}
${SectionShopProductListFragmentDoc}
${SectionRelatedShopProductsListFragmentDoc}
${VideoEmbedFragmentDoc}
${TableFragmentDoc}`;
export const SegmentsDocument = gql`
    query segments($locale: SiteLocale, $first: IntType = 100, $skip: IntType) {
  _allSegmentsMeta(locale: $locale) {
    count
  }
  allSegments(
    locale: $locale
    first: $first
    skip: $skip
    orderBy: _firstPublishedAt_DESC
  ) {
    _modelApiKey
    headline
    description
  }
}
    `;
export const ShopProductsDocument = gql`
    query shopProducts($locale: SiteLocale, $first: IntType = 100, $skip: IntType, $eq: [ItemId], $neq: String, $anyIn: [ItemId], $publishTranslation: BooleanType = true) {
  _allShopProductsMeta(
    locale: $locale
    filter: {category: {allIn: $eq}, publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
  ) {
    count
  }
  allShopProducts(
    locale: $locale
    first: $first
    skip: $skip
    filter: {category: {allIn: $eq, anyIn: $anyIn}, publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
    orderBy: _firstPublishedAt_DESC
  ) {
    _modelApiKey
    description
    price
    id
    title
    variation
    tag
    productFeatureOrDescription {
      feature
      descriptionOrValue
    }
    slug
    publishTranslation
    noIndex
    category {
      title
      description
    }
    additionalProductLink {
      __typename
      ... on ShopProductRecord {
        id
        title
        slug
      }
    }
    images {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: format, crop: focalpoint, fit: crop, ar: "16:9"}
      ) {
        ...Image
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const ShopProductDocument = gql`
    query shopProduct($locale: SiteLocale, $slug: String) {
  shopProduct(locale: $locale, filter: {slug: {eq: $slug}}) {
    _allSlugLocales {
      value
      locale
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    createdAt
    id
    description
    price
    variation
    tag
    productFeatureOrDescription {
      feature
      descriptionOrValue
    }
    category {
      title
      description
    }
    additionalProductLink {
      __typename
      ... on ShopProductRecord {
        id
        title
        slug
      }
    }
    images {
      alt
      url
      width
      height
      responsiveImage {
        ...Image
      }
    }
    body {
      blocks {
        __typename
        ... on ButtonRecord {
          id
          label
          variant
          icon
          reference {
            ... on ArticleRecord {
              id
              slug
            }
            ... on PageRecord {
              id
              slug
            }
          }
          externalLink
        }
        ... on HtmlRecord {
          id
          code
        }
        ... on ImageRecord {
          id
          image {
            alt
            url
            width
            height
            responsiveImage {
              ...Image
            }
          }
        }
        ... on ImageGalleryRecord {
          id
          images {
            alt
            url
            width
            height
            responsiveImage(
              imgixParams: {auto: format, crop: focalpoint, fit: crop, ar: "16:9"}
            ) {
              ...Image
            }
          }
        }
        ... on VideoEmbedRecord {
          id
          video {
            url
            title
            thumbnailUrl
            height
            provider
            providerUid
            width
          }
        }
        ... on TableRecord {
          id
          table
        }
      }
      links {
        __typename
        ... on PageRecord {
          id
          title
          slug
        }
        ... on ArticleRecord {
          id
          slug
          title
        }
      }
      value
    }
    title
    slug
    publishTranslation
    noIndex
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${ImageFragmentDoc}`;
export const ShopCategoryDocument = gql`
    query shopCategory($locale: SiteLocale, $slug: String) {
  shopCategory(locale: $locale, filter: {slug: {eq: $slug}}) {
    _allSlugLocales {
      value
      locale
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    createdAt
    id
    description
    title
    slug
    publishTranslation
    noIndex
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    app(variables?: AppQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppQuery>(AppDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'app', 'query', variables);
    },
    articles(variables?: ArticlesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArticlesQuery>(ArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'articles', 'query', variables);
    },
    article(variables?: ArticleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArticleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArticleQuery>(ArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'article', 'query', variables);
    },
    index(variables?: IndexQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IndexQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IndexQuery>(IndexDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'index', 'query', variables);
    },
    page(variables?: PageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageQuery>(PageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'page', 'query', variables);
    },
    programCategories(variables?: ProgramCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProgramCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProgramCategoriesQuery>(ProgramCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'programCategories', 'query', variables);
    },
    programProducts(variables?: ProgramProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProgramProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProgramProductsQuery>(ProgramProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'programProducts', 'query', variables);
    },
    programProduct(variables?: ProgramProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProgramProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProgramProductQuery>(ProgramProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'programProduct', 'query', variables);
    },
    segments(variables?: SegmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SegmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SegmentsQuery>(SegmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'segments', 'query', variables);
    },
    shopProducts(variables?: ShopProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShopProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShopProductsQuery>(ShopProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shopProducts', 'query', variables);
    },
    shopProduct(variables?: ShopProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShopProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShopProductQuery>(ShopProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shopProduct', 'query', variables);
    },
    shopCategory(variables?: ShopCategoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShopCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShopCategoryQuery>(ShopCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shopCategory', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;